import { Component, OnInit, ViewChild } from '@angular/core';
import { AfterViewChecked, ElementRef  } from '@angular/core';
import { CommonService } from '../../service/common.service';
import { User } from '../../models/user';
import { Persona } from '../../models/persona';
import { Messaggio } from '../../models/messaggio';

//interface User {
//    id: number;
//    name: string;
//}

//interface Message {
//    id: number;
//    text: string;
//    sender: string,
//    timestamp: Date;
//}

class Personamessagginonletti {
    codicepersona: number;
    numeromessaggi: number; 
    constructor() {
        this.codicepersona = 0;
        this.numeromessaggi = 0;
    }
}

@Component({
    selector: 'app-chat',
    templateUrl: './chat.component.html',
    styleUrls: ['./chat.component.css']
})
export class ChatComponent implements OnInit{
    users: User[] = [];
    persone: Persona[] = [];
    personemessagginonletti:[Personamessagginonletti];
    
    senderid: number=0;
    private refreshInterval: any;
    private readonly REFRESH_INTERVAL = 5000; // 5 secondi

   
    constructor(private commonService: CommonService) {
 
    }

    ngOnInit(): void {
        this.refreshPannelloMessaggi();
        this.startRefresh();   
    }

   
    
    refreshPannelloMessaggi(): void {
        this.personemessagginonletti=[new Personamessagginonletti()];
      
    //       this.commonService.nuovimessaggichat=false;
            this.commonService.getUser(sessionStorage.getItem('username')).subscribe((user: User) => {
                this.senderid = user.Codicepersona;
                this.commonService.getPersone(this.commonService.currentIstanza.Codice).subscribe((data: Persona[]) => {
                    let temp=data;
                    this.commonService.getMessaggiRicevuti(user.Codicepersona).subscribe((messaggiricevuti: Messaggio[]) => {   
                        this.persone=[];     
                        temp.forEach((persona: Persona) => {
                            if (persona.Codice != this.senderid) {
                                this.persone.push(persona);
                                
                                let messaggiFiltrati = messaggiricevuti.filter(messaggio => 
                                    messaggio.Senderid === persona.Codice && 
                                    messaggio.Letto !== 'YES'
                                );
                                let personamessagginonletti:Personamessagginonletti=new Personamessagginonletti();
                                personamessagginonletti.codicepersona=persona.Codice;
                                personamessagginonletti.numeromessaggi=messaggiFiltrati.length;         
                                this.personemessagginonletti.push(personamessagginonletti);                                
                            }
                        }); 
                        
                    });   

                });
            
            });
        
    }

    

    getNumeromessagginonletti(codicepersona:number):number{
        let rc:number=0;
        this.personemessagginonletti.forEach((p:Personamessagginonletti) => {
            if (p.codicepersona==codicepersona) {
                rc=p.numeromessaggi;
            }
        });
        return rc;
    }
    resetNumeromessagginonletti(codicepersona:number){
        let rc:number=0;
        let temp:[Personamessagginonletti]=[new Personamessagginonletti()];
    
        this.personemessagginonletti.forEach((p:Personamessagginonletti) => {      
            if (p.codicepersona!=codicepersona) {
                temp.push(p);
            }else{
                let personamessagginonletti:Personamessagginonletti=new Personamessagginonletti();
                personamessagginonletti.codicepersona=codicepersona;
                personamessagginonletti.numeromessaggi=0;      
                this.personemessagginonletti.push(personamessagginonletti);      
            }
        });
        this.personemessagginonletti=temp;
    }

    selectedPersona: Persona | null = null;

    messages: Messaggio[] = [];
    newMessage: string = '';

    selectPersona(persona: Persona) {
        this.selectedPersona = persona;
        this.resetNumeromessagginonletti(persona.Codice);
        this.commonService.setletto(this.senderid, this.selectedPersona.Codice).subscribe((data: Messaggio[]) => {

        });
        this.loadMessages();
        // Avvia il refresh periodico
        this.startRefresh();
    }

    private loadMessages() {
      
        if (this.selectedPersona) {
            this.commonService.getConversation(this.senderid, this.selectedPersona.Codice).subscribe((data: Messaggio[]) => {
             //   this.commonService.setletto(this.senderid, this.selectedPersona.Codice).subscribe((data: Messaggio[]) => {
                    this.messages = data;
                    this.scrollToBottom();
            //    });
                
            });
        }
    }

    private startRefresh() {
        // Ferma eventuali refresh precedenti
        this.stopRefresh();
        
        // Avvia un nuovo intervallo
        this.refreshInterval = setInterval(() => {
            
            this.refreshPannelloMessaggi();
            this.loadMessages();
        }, this.REFRESH_INTERVAL);
    }

    private stopRefresh() {
        if (this.refreshInterval) {
            clearInterval(this.refreshInterval);
            this.refreshInterval = null;
        }
    }

    ngOnDestroy() {
        // Assicurati di fermare il refresh quando il componente viene distrutto
        this.stopRefresh();
        this.commonService.nuovimessaggichat=false;
    }

    sendMessage() {
        if (!this.newMessage.trim() || !this.selectedPersona) return;
/*
        const userMessage: Messaggio = {
            Id: this.messages.length + 1,
            Testo: this.newMessage,
            sender: 'user',
            timestamp: new Date()
        };
 */
        const userMessage: Messaggio=new Messaggio();
        userMessage.Testo=this.newMessage         
        userMessage.Data=new Date(); 
        userMessage.Stile='sender';
        userMessage.Receiverid=this.selectedPersona.Codice;
        userMessage.Senderid=this.senderid;
        userMessage.Sender=null;
        userMessage.Receiver=this.selectedPersona;
        userMessage.Id=0;


        this.messages.push(userMessage);
        this.scrollToBottom();
        this.commonService.saveMessaggio(userMessage).subscribe((data: Messaggio) => {
            console.log(data);
            this.newMessage = '';
            this.scrollToBottom();
        });
        
/*
        setTimeout(() => {
            const botMessage: Messaggio = {
                Testo: `Risposta da ${this.selectedPersona?.Nome} ${this.selectedPersona?.Cognome}`,
                Sender: new Persona(),
                Data: new Date(),
                Id: 0,
                Receiver: this.receiver,
                Senderid:this.senderid,
                Receiverid:this.receiver.Codice,
                Stile: 'receiver'
            };
            this.messages.push(botMessage);
        }, 1000);
        */
    }
    @ViewChild('messagesEnd') private messagesEnd: ElementRef;

    ngAfterViewChecked(): void {
        this.scrollToBottom();
    }


    private scrollToBottom(): void {
        try {
            this.messagesEnd.nativeElement.scrollIntoView({ behavior: 'smooth' });
        } catch (err) {
         //   console.error('Errore durante lo scroll:', err);
        }
    }

}
